<template>
  <footer>
    <div class="summary">
      <div class="summary-item">
        <h3 class="summary-title">精灵数据</h3>
        <a href="javascript:void(0)" class="about-us">关于我们</a>
        <a href="javascript:void(0)" class="partner">合作伙伴</a>
        <a href="javascript:void(0)" class="partner" @click="$router.push('/privacy')">隐私协议</a>
      </div>
      <div class="summary-item">
        <h3 class="summary-title">联系我们</h3>
        <a href="javascript:void(0)" class="telephone"
          >联系邮箱: support@jldatas.com</a
        >
        <a href="javascript:void(0)" class="telephone">联系电话: 18816806937</a>
        <a href="javascript:void(0)">客服QQ: 85302864</a>
      </div>
      <div class="summary-item">
        <h3 class="summary-title">微信公众号</h3>
        <img src="../assets/img/home/qrcode.jpg" alt class="qr-code" />
        <a href="javascript:void(0)">扫码关注公众号</a>
      </div>
    </div>
    <div class="copyright">
      <button class="btn-language">中文</button>
      <p @click="localToCopy">
        CP证:粤ICP备19113748号 Copyright © 2019 广州鲸灵科技有限公司
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      copyLink: "http://beian.miit.gov.cn", // /publish/query/indexFirst.action
    };
  },
  methods: {
    localToCopy() {
      window.open(this.copyLink);
    },
  },
};
</script>

<style lang="less" scoped>
//footer组件
footer {
  padding: 86px 0 0;
  background-color: #06080a;
  height: auto;

  > * {
    padding: 0 144px;
  }
  .summary {
    display: flex;

    .summary-item {
      width: 345px;
      flex-shrink: 1;
      &:last-child {
        width: auto;
        margin-left: 280px;
        margin-bottom: 18px;
      }

      > * {
        display: block;
        color: #ffffff;
        margin-bottom: 12px;
      }
      .summary-title {
        font-size: 16px;
        font-weight: 700;
        padding-bottom: 20px;
      }
      a {
        font-size: 14px;
      }
      .qr-code {
        width: 110px;
      }
    }
  }
  .copyright {
    min-height: 65px;
    text-align: center;
    line-height: 65px;
    border-top: 1px solid rgba(255, 255, 255, 0.25);
    display: flex;
    align-items: center;

    > * {
      color: rgba(255, 255, 255, 0.65);
      font-size: 14px;
    }
    .btn-language {
      display: block;
      width: auto;
      white-space: nowrap;
      padding: 5px 20px;
      line-height: 32px;
      border-radius: 2px;
      border: 1px solid rgba(255, 255, 255, 0.65);
    }
    p {
      padding-left: 30px;
      min-height: 100%;
      height: auto;
      color: #9b9b9b;
      cursor: pointer;
    }
  }
}
@media screen and (min-width: 0px) and (max-width: 720px) {
  .summary {
    flex-direction: column;

    .summary-item {
      width: 100% !important;
      display: flex;
      flex-wrap: wrap;
      &:last-child {
        margin-left: 0 !important;
        margin-bottom: 18px;
        .summary-title {
          text-align: center;
        }
        > .qr-code {
          width: 340px;
          height: 340px;
          margin: 0 auto;
          margin-bottom: 30px;
        }
        > a {
          width: 100% !important;
          text-align: center;
        }
      }
      .summary-title {
        font-size: 18px !important;
        width: 100%;
        flex-shrink: 0;
        margin-bottom: 16px;
      }
      > a {
        width: calc(100% / 3);
        margin-bottom: 30px;
        color: #9b9b9b;
        font-size: 16px;
      }
    }
  }
  .copyright {
    > * {
      font-size: 16px !important;
    }
    .btn-language {
      display: none !important;
    }
    p {
      padding: 20px 0;
    }
  }
}
</style>
